import { Controller } from "@hotwired/stimulus"

// § 3.3 Tier 3 — flat-file schedule form panel.
//
// Swap-on-change behaviors:
//   - Frequency change → show/hide day-of-week (weekly) or day-of-month
//     (monthly) input panels.
//   - Delivery-destination-kind change → show/hide the recipients
//     textarea (only meaningful for `email_attachment` and
//     `download_only`; SFTP reads creds off the connection's metadata).
export default class extends Controller {
  static targets = ["frequency", "weeklyPanel", "monthlyPanel",
                    "deliveryKind", "recipientsPanel", "recipientsBuffer"]
  static values = {
    initialFrequency: String,
    initialDeliveryKind: String
  }

  connect() {
    if (this.hasFrequencyTarget && !this.frequencyTarget.value) {
      this.frequencyTarget.value = this.initialFrequencyValue || "daily"
    }
    if (this.hasDeliveryKindTarget && !this.deliveryKindTarget.value) {
      this.deliveryKindTarget.value = this.initialDeliveryKindValue || "sftp"
    }
    this._applyFrequency(this._currentFrequency())
    this._applyDeliveryKind(this._currentDeliveryKind())
  }

  frequencyChanged() {
    this._applyFrequency(this._currentFrequency())
  }

  deliveryKindChanged() {
    this._applyDeliveryKind(this._currentDeliveryKind())
  }

  // Newline-list to JSON conversion happens server-side (see
  // IntegrationFlatFileSchedulesController#parse_delivery_config) — the
  // textarea ships its raw text up. Nothing to do client-side, but the
  // hook stays so future enrichments (live email-validity badges) can
  // ride here without restructuring the markup.
  recipientsChanged() {
    // intentional no-op; server handles parsing.
  }

  _currentFrequency() {
    return this.hasFrequencyTarget ? this.frequencyTarget.value : "daily"
  }

  _currentDeliveryKind() {
    return this.hasDeliveryKindTarget ? this.deliveryKindTarget.value : "sftp"
  }

  _applyFrequency(freq) {
    this._toggle(this.weeklyPanelTarget, freq === "weekly")
    this._toggle(this.monthlyPanelTarget, freq === "monthly")
  }

  _applyDeliveryKind(kind) {
    this._toggle(this.recipientsPanelTarget,
                 kind === "email_attachment" || kind === "download_only")
  }

  _toggle(el, visible) {
    if (!el) return
    if (visible) {
      el.classList.remove("hidden")
    } else {
      el.classList.add("hidden")
    }
  }
}
